const fr: Record<string, string> = {
  'features.guitarNotes.showNote': 'Afficher',
  'features.guitarNotes.hideNote': 'Masquer',
  'features.guitarNotes.nextNote': 'Suivante',
  'features.guitarNotes.notes': 'Notes',
  'features.guitarNotes.octaves': 'Octaves',
  'features.guitarNotes.loadingSamples': 'Chargement des samples guitare…',
  'features.guitarNotes.modeAuto': 'Auto',
  'features.guitarNotes.modeManual': 'Manuel',
  'features.guitarNotes.stop': 'Pause',
  'features.guitarNotes.resume': 'Reprendre',
  'features.guitarNotes.hideDuration': 'Réflexion',
  'features.guitarNotes.revealDuration': 'Révélation',
  'features.guitarNotes.fretCount': 'Cases',
  'features.guitarNotes.repeatNote': 'Rejouer',
  'features.guitarNotes.muteSound': 'Couper le son',
  'features.guitarNotes.unmuteSound': 'Activer le son',
  'features.guitarNotes.showFretboard': 'Afficher le manche',
  'features.guitarNotes.hideFretboard': 'Masquer le manche',
};

export default fr;
